import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, observable, runInAction } from "mobx";
import { EProductPlanAdditionalTeaching, EProductPlanPaymentInterval, routeLocationPaddleProductPlanGet } from "@devowl-wp/api-real-commerce";
import { isPaidService } from "@devowl-wp/real-commerce-order-summary";
import { RealCommerceError } from "../../../exceptions/realCommerceError.js";
import { localizePaymentInterval } from "../../../others/localizePaymentInterval.js";
import { getLegalManufacturerUrls, getLegalSellerUrls } from "../../../utils/legalEntities.js";
import { realCommerceRequest } from "../../../utils/realCommerceRequest.js";
class Product {
    get websiteCount() {
        return +(this.data.productPlan.description?.match(/(\d+)+ website/i)?.[1] || 0);
    }
    get isOneTime() {
        return this.data.productPlan.paymentInterval === EProductPlanPaymentInterval.OneTime;
    }
    /**
     * Whether the plan represents a paid human service (e.g. Cookie-Expert
     * setup) rather than a software license. Plugin licenses — including
     * one-time lifetime plans like Real Media Library — return `false`.
     *
     * Delegates to the iso `isPaidService(EProductType)` helper when
     * `productPlan.product.type` is populated. The `additionalTeachings`
     * fallback covers backends that have not yet back-filled the column
     * (services carry `noLegalAdviceContractWork` or `dpaForPayedSupport`;
     * plugin licenses carry `exclusionOfRevocation`).
     */ // TODO: Drop the `additionalTeachings` fallback once every backend response carries `productPlan.product.type`.
    get isPaidService() {
        const productType = this.data.productPlan.product.type;
        if (productType !== undefined) {
            return isPaidService(productType);
        }
        const teachings = this.data.productPlan.additionalTeachings ?? [];
        return teachings.some(({ teaching })=>teaching === EProductPlanAdditionalTeaching.NoLegalAdviceContractWork || teaching === EProductPlanAdditionalTeaching.DpaForPayedSupport);
    }
    get labelPaymentInterval() {
        if (!this.data) {
            return "";
        }
        return localizePaymentInterval(this.data.productPlan.paymentInterval);
    }
    get seller() {
        return getLegalSellerUrls();
    }
    get manufacturer() {
        return getLegalManufacturerUrls();
    }
    constructor(data, store){
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
    /**
     * Load the backend data from backend.
     *
     * @param params
     * @param store
     */ static async loadProduct(params, store) {
        let result;
        try {
            result = await realCommerceRequest({
                location: routeLocationPaddleProductPlanGet,
                params
            });
        } catch (e) {
            throw new RealCommerceError(e);
        }
        return new Product(result, store);
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof IRouteResponsePaddleProductPlanGet === "undefined" ? Object : IRouteResponsePaddleProductPlanGet)
], Product.prototype, "data", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Product.prototype, "websiteCount", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Product.prototype, "isOneTime", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Product.prototype, "isPaidService", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Product.prototype, "labelPaymentInterval", null);
export { Product };
